import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DeleteModalStatus } from '../models/global-interface';

@Injectable({
  providedIn: 'root'
})
export class DeleteModalService {

  private initialState: DeleteModalStatus =      {
    type: 'check',
    id: ''
  };

  private deleteModalSubject = new BehaviorSubject<DeleteModalStatus>(this.initialState);
  private closeModalSubject = new BehaviorSubject<boolean>(false);
  public deleteModal$ = this.deleteModalSubject.asObservable();
  public closeModal$ = this.closeModalSubject.asObservable();
  
  constructor() { }

  setDeleteModal(status: DeleteModalStatus) {
    this.deleteModalSubject.next(status);
  }

  closeAndDeleteModal() {
    this.closeModalSubject.next(true);
  }

  stopCloseAndDeleteModal() {
    this.closeModalSubject.next(false);
  }
}